import APIError from '../APIError';

class TraderError extends APIError {
  constructor(code, details = null) {
    super(code, 'TraderError', details);
  }
}

export default TraderError;
